import FeatureTiles from '@/components/_organisms/FeatureTiles';
import { ModuleFeatureTilesFragment } from '@/graphql';
import { getSingleLink } from '@/lib/craft-utils';
import gtm from '@/lib/gtm';
import { getSingle, maybeNotSet, notEmpty } from '@/lib/typescript-helpers';
import { FC } from 'react';

interface FeatureTilesModuleProps {
  props: CraftModuleFragment<ModuleFeatureTilesFragment>;
}

const FeatureTilesModule: FC<FeatureTilesModuleProps> = ({ props }) => {
  if (Array.isArray(props)) {
    props = props[0];
  }

  if (!props) return null;

  const featuresCta = getSingleLink(props.featuresCta);

  return (
    <FeatureTiles
      heading={props.heading ?? undefined}
      items={
        props.featureTiles
          .filter(notEmpty)
          .map((item) => {
            const icon = getSingle(item.icon);

            if (!icon?.url || !item.text) return null;

            return {
              text: item.text,
              icon: {
                src: icon.url,
              },
            };
          })
          .filter(notEmpty) ?? []
      }
      cta={
        featuresCta
          ? {
              text: featuresCta.text,
              href: featuresCta.url,
              onClick() {
                gtm.track('click', {
                  element_type: 'button',
                  element_label: maybeNotSet(featuresCta.text),
                  location: 'Feature Tiles',
                });
              },
            }
          : undefined
      }
    />
  );
};

export default FeatureTilesModule;
